export default __webpack_public_path__ + "static/media/greeting-man.25c303aa.svg";